import api from 'api'
import type {
  InvoiceConfig,
  InvoiceConfigCustomWeek,
} from './getInvoiceConfigs'

export type UpdateInvoiceConfigRequest = {
  invoiceConfigId: number
  breakdownLevels: InvoiceConfig['breakdownLevels']
  customWeek: InvoiceConfigCustomWeek | null
}

export type UpdateInvoiceConfigResponse = {
  updatedAt: string
}

export const updateInvoiceConfig = async ({
  invoiceConfigId,
  ...body
}: UpdateInvoiceConfigRequest): Promise<UpdateInvoiceConfigResponse> => {
  const response = await api.patch<UpdateInvoiceConfigResponse>(
    `/admin/invoice_config/${invoiceConfigId}`,
    body
  )
  return response.data
}
